module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./MyCollectView.js"));
	}, "MyCollectView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MyCollectView!./src/pages/Shop/Member/Personal/MyCollect/MyCollectView.js
// module id = 997
// module chunks = 431